import Box from '../Global/Box'
import ContentHeader from '../Layout/ContentHeader'
import KnowAccordion from './Components/KnowAccordion'

export const KnowledgeView = () => {
  
  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <>
            <div className="col-8">
              <h1 className="header-title">
                Directorio de Grupos y Categorías
              </h1>
              
            </div>
          </>
        }
        breadcrumb=""
        windowTitle="Directorio de Grupos y Categorías"
      />
      
          <Box
              title=""
              className="col-12 col-lg-12 col-xl-12 col-md-12 col-sm-12"
              content={<KnowAccordion />}

          />
    </>
  )
}

export default KnowledgeView
